module.exports = __webpack_public_path__ + "img/sparkling-punch.39679e17.jpg";